import moment from "moment";
import React from "react";
import { ImCheckmark } from "react-icons/im";
import { IoMdClose } from "react-icons/io";
import { RateTypeShippingEnum } from "../../../../../enums/RateTypeShippingEnum";
import formatCep from "../../../../../utils/FormatCep";
import { formatCPF } from "../../../../../utils/validators/IsValidCpfCnpj";
import styles from "./styles.module.scss";

import { ReactComponent as Box } from "../../../../../assets/icons/box.svg";
import { ReactComponent as BoxSearch } from "../../../../../assets/icons/box-search.svg";
import { conciliationProperty } from "../../../../../utils/conciliationProperty";
import { addressInfoHandled } from "../../../../../utils/handleAddress";

import { DeliveryTypeTitleEnum } from "../../../../../enums/DeliveryTypeEnum";

const CardConciliation = ({ conciliation }) => {

  const returnInfo = ({ type, measure, name, money, conciliation }) => {
    const {
      conciliationProp,
      conciliationPropDiff,
      oldProp
    } = conciliationProperty(type, conciliation);

    if (
      typeof conciliationPropDiff === "number" &&
      conciliationPropDiff !== 0
    ) {
      if (money) {
        return (
          <tr>
            <td className={styles.titleTable} role={"notOk"}>
              {name}
              <span>
                {`${new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL"
                }).format(oldProp)}`}
              </span>
              <IoMdClose color="#CA1818" size={17} />
            </td>
            <td className={styles.titleTable} role={"ok"}>
              {name}
              <span>
                {`${new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL"
                }).format(conciliationProp)}`}
              </span>
              <ImCheckmark color="#409E6A" size={15} />
            </td>
          </tr>
        );
      }

      if (name === "Peso faturado:") {
        if (oldProp !== conciliationProp) {
          return (
            <tr>
              <td className={styles.titleTable} role={"notOk"}>
                {name}
                <span>{`${String(oldProp).replace(".", ",")}${measure}`}</span>
                <IoMdClose color="#CA1818" size={17} />
              </td>
              <td className={styles.titleTable} role={"ok"}>
                {name}
                <span>
                  {`${String(conciliationProp).replace(".", ",")}${measure}`}
                </span>
                <ImCheckmark color="#409E6A" size={15} />
              </td>
            </tr>
          );
        } else {
          return (
            <tr>
              <td className={styles.titleTable}>
                {name}
                <span>{`${String(oldProp).replace(".", ",")}${measure}`}</span>
              </td>
              <td className={styles.titleTable}>
                {name}
                <span>
                  {`${String(conciliationProp).replace(".", ",")}${measure}`}
                </span>
              </td>
            </tr>
          );
        }
      }

      return (
        <tr>
          <td className={styles.titleTable} role={"notOk"}>
            {name}
            <span>{`${String(oldProp).replace(".", ",")}${measure}`}</span>
            <IoMdClose color="#CA1818" size={17} />
          </td>
          <td className={styles.titleTable} role={"ok"}>
            {name}
            <span>
              {`${String(conciliationProp).replace(".", ",")}${measure}`}
            </span>
            <ImCheckmark color="#409E6A" size={15} />
          </td>
        </tr>
      );
    } else if (type === "type") {
      const displayProp = DeliveryTypeTitleEnum[conciliationProp] || conciliationProp;
      const displayPropDiff = DeliveryTypeTitleEnum[conciliationPropDiff] || conciliationPropDiff;
      if (!!conciliationPropDiff && conciliationProp !== conciliationPropDiff) {
        return (
          <tr role={"notOk"}>
            <td className={styles.titleTable}>
              {name}
              <span>{`${displayPropDiff}${measure}`}</span> 
              <IoMdClose color="#CA1818" size={17} />
            </td>
            <td className={styles.titleTable} role={"ok"}>
              {name}
              <span>{`${displayProp}${measure}`}</span>
              <ImCheckmark color="#409E6A" size={15} />
            </td>
          </tr>
        );
      } else {
        return (
          <tr role={"notOk"}>
            <td className={styles.titleTable}>
              {name}
              <span>{`${displayProp}${measure}`}</span>
            </td>
            <td className={styles.titleTable}>
              {name}
              <span>{`${displayProp}${measure}`}</span>
            </td>
          </tr>
        );
      }
    } else if (
      typeof conciliationPropDiff === "string" &&
      conciliationPropDiff !== "" &&
      conciliationPropDiff !== "Não"
    ) {
      return (
        <tr role={"notOk"}>
          <td className={styles.titleTable}>
            {name}
            <span>{`${conciliationProp}${measure}`}</span>
            <IoMdClose color="#CA1818" size={17} />
          </td>
          <td className={styles.titleTable} role={"ok"}>
            {name}
            <span>{`${conciliationPropDiff}${measure}`}</span>
            <ImCheckmark color="#409E6A" size={15} />
          </td>
        </tr>
      );
    } else {
      return (
        <tr className={styles.rowTable}>
          <td className={styles.titleTable}>
            {name}
            <span>
              {money
                ? `${new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL"
                }).format(Number(conciliationProp))}`
                : `${conciliationProp}${measure}`}
            </span>
          </td>
          <td className={styles.titleTable}>
            {name}
            <span>
              {money
                ? `${new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL"
                }).format(Number(conciliationProp))}`
                : `${conciliationProp}${measure}`}
            </span>
          </td>
        </tr>
      );
    }
  };

  return (
    <div className={`${styles.cardWrapper} ${conciliation.blocked}`}>
      <div className={styles.cardBody}>
        <div className={styles.cardContent}>
          <h3>INFORMAÇÕES GERAIS</h3>
          <hr />
          <div className={styles.collectInfoContainer}>
            <div className={styles.collectInfo}>
              <h4>Dados do Pacote</h4>
              <p className={styles.highlighted}>
                <strong>Cod. de envio:</strong> {conciliation?.shipping?.sro}
              </p>
              <p className={styles.highlighted}>
                <strong>Prazo de entrega:</strong>{" "}
                {conciliation?.shipping?.correios?.prazoEntrega < 1 ? "no mesmo dia" : `${conciliation?.shipping?.correios?.prazoEntrega} ${conciliation?.shipping?.correios?.prazoEntrega > 1
                    ? "dias úteis"
                    : "dia útil"
                  }`}
              </p>
              <p className={styles.highlighted}>
                <strong>Valor segurado:</strong>{" "}
                {conciliation?.shipping?.insurance ? `${new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL"
                }).format(
                  conciliation?.shipping?.correios?.valorValorDeclarado
                )}` : 'R$ 00,00'}
              </p>
              <p className={styles.highlighted}>
                <strong>A.R:</strong>{" "}
                {`${conciliation?.shipping?.correios?.valorAvisoRecebimento > 0
                  ? "Sim"
                  : "Não"
                  }`}
              </p>
              <p className={styles.highlighted}>
                <strong>M.P:</strong>{" "}
                {`${conciliation?.shipping?.correios?.valorMaoPropria > 0
                  ? "Sim"
                  : "Não"
                  }`}
              </p>
              <p className={styles.highlighted}>
                <strong>Coleta:</strong>{" "}
                {`${conciliation?.shipping?.rateType ===
                  RateTypeShippingEnum.COLLECT
                  ? "Sim"
                  : "Não"
                  }`}
              </p>
              {conciliation?.shipping?.rateType ===
                RateTypeShippingEnum.RETAIL && (
                  <p className={`${styles.highlighted} ${styles.agency}`}>
                    <strong>Agência:</strong> {conciliation.agency}
                  </p>
                )}
              <p className={styles.highlighted}>
                <strong>Pago em:</strong>{" "}
                {moment(conciliation?.shipping?.collect?.created_at).format(
                  "DD/MM/YYYY - HH:mm"
                )}
              </p>
            </div>
            <div className={styles.collectInfo}>
              <h4>Destinatário</h4>
              <p className={styles.highlighted}>
                <strong>Nome:</strong>{" "}
                {conciliation?.shipping?.destination?.name}
              </p>
              <p className={styles.highlighted}>
                <strong>
                  {conciliation?.shipping?.destination?.document === 11
                    ? "CPF:"
                    : "CNPJ:"}
                </strong>{" "}
                {formatCPF(conciliation?.shipping?.destination?.document)}
              </p>
              <p style={{ maxWidth: "264px" }} className={styles.highlighted}>
                <strong>CEP: </strong>{" "}
                {formatCep(conciliation?.shipping?.destination?.zip)}
              </p>

              <p>
                <strong>Endereço: </strong>
                {addressInfoHandled({
                  street: conciliation?.shipping?.destination?.street,
                  number: conciliation?.shipping?.destination?.number,
                  complement: conciliation?.shipping?.destination?.complement,
                  district: conciliation?.shipping?.destination?.district
                })}
                {`${conciliation?.shipping?.destination?.city}/${conciliation?.shipping?.destination?.state}`}
              </p>
            </div>
          </div>
        </div>

        <div className={styles.cardContent}>
          <h3>
            CONFERÊNCIA (realizada em{" "}
            {moment(conciliation?.created_at)
              .subtract(3, "hours")
              .format("DD/MM/YYYY - HH:mm")}
            )
          </h3>
          <hr />
          <table className={styles.table}>
            <thead>
              <tr>
                <td style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  <Box />
                  <h5>Original</h5>
                </td>
                <td style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  <BoxSearch />
                  <h5>Conferido</h5>
                </td>
              </tr>
            </thead>
            <tbody>
              {conciliation?.shipping?.rateType ===
                RateTypeShippingEnum.RETAIL &&
                returnInfo({
                  type: "originCity",
                  measure: "",
                  name: "De:",
                  conciliation
                })}
              {returnInfo({
                type: "height",
                measure: "cm",
                name: "Altura:",
                conciliation
              })}

              {returnInfo({
                type: "width",
                measure: "cm",
                name: "Largura:",
                conciliation
              })}

              {returnInfo({
                type: "length",
                measure: "cm",
                name: "Comprimento:",
                conciliation
              })}

              {returnInfo({
                type: "format",
                measure: "",
                name: "Formato:",
                conciliation
              })}

              {returnInfo({
                type: "weight",
                measure: "kg",
                name: "Peso:",
                conciliation
              })}

              {returnInfo({
                type: "billedWeight",
                measure: "kg",
                name: "Peso faturado:",
                conciliation
              })}

              {returnInfo({
                type: "type",
                measure: "",
                name: "Tipo:",
                conciliation
              })}

              {conciliation?.shipping?.rateType ===
                RateTypeShippingEnum.RETAIL &&
                returnInfo({
                  type: "rateType",
                  measure: "",
                  name: "Coleta:",
                  conciliation
                })}

              {returnInfo({
                type: "price",
                measure: "",
                name: "Preço:",
                money: true,
                conciliation
              })}

              {returnInfo({
                type: "discount",
                measure: "",
                name: "Desconto:",
                money: true,
                conciliation
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CardConciliation;
